import { render, staticRenderFns } from "./NewsTwo.vue?vue&type=template&id=22bb1ee0&scoped=true"
import script from "./NewsTwo.vue?vue&type=script&lang=js"
export * from "./NewsTwo.vue?vue&type=script&lang=js"
import style0 from "./NewsTwo.vue?vue&type=style&index=0&id=22bb1ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bb1ee0",
  null
  
)

export default component.exports